// app/javascript/controllers/track_count_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "container", "template"]

  connect() {
    // If tracks were pre-rendered server-side (e.g. after a validation error),
    // start nextIndex after the highest existing index to avoid collisions.
    const existing = this.containerTarget.querySelectorAll("[data-track-section]")
    if (existing.length > 0) {
      this.nextIndex = existing.length
    } else {
      this.nextIndex = 0
    }
    this.updateTracks()
  }

  // Called when the Track Count number field changes
  updateTracks() {
    const count = parseInt(this.countTarget.value) || 1
    const clamped = Math.min(Math.max(count, 1), 10)
    const existing = this.containerTarget.children.length

    if (clamped > existing) {
      for (let i = 0; i < (clamped - existing); i++) {
        this.appendTrack()
      }
    } else if (clamped < existing) {
      while (this.containerTarget.children.length > clamped) {
        this.containerTarget.removeChild(this.containerTarget.lastElementChild)
      }
    }

    this.renumberTracks()
  }

  // "Add Track" button
  addTrack(event) {
    event.preventDefault()
    const current = this.containerTarget.children.length
    if (current >= 10) return

    this.appendTrack()
    this.syncCount()
    this.renumberTracks()
  }

  // "Remove Track" link inside each track
  removeTrack(event) {
    event.preventDefault()
    if (this.containerTarget.children.length <= 1) return

    const trackEl = event.target.closest("[data-track-section]")
    if (trackEl) {
      trackEl.remove()
      this.syncCount()
      this.renumberTracks()
    }
  }

  // --- Private helpers ---

  appendTrack() {
    const templateContent = this.templateTarget.content
    const clone = templateContent.cloneNode(true)
    const wrapper = document.createElement("div")
    wrapper.appendChild(clone)

    const idx = this.nextIndex
    wrapper.innerHTML = wrapper.innerHTML.replaceAll("__INDEX__", idx.toString())
    wrapper.innerHTML = wrapper.innerHTML.replaceAll("__DISPLAY_NUM__", "0") // will be renumbered

    this.containerTarget.appendChild(wrapper.firstElementChild)
    this.nextIndex = idx + 1
  }

  // Update the Track Count input to match actual number of tracks
  syncCount() {
    this.countTarget.value = this.containerTarget.children.length
  }

  // Renumber the display labels (Track #1, Track #2, etc.)
  renumberTracks() {
    const tracks = this.containerTarget.querySelectorAll("[data-track-section]")
    tracks.forEach((track, i) => {
      const label = track.querySelector("[data-track-label]")
      if (label) label.textContent = `Track #${i + 1}`
    })
  }
}
